// extracted by mini-css-extract-plugin
export var actions = "_4c-0";
export var actionsContainer = "_4c-6";
export var border = "_4c-1";
export var childFullHeight = "_4c-d";
export var collapse = "_4c-2";
export var content = "_4c-8";
export var contentChild = "_4c-c";
export var fullscreen = "_4c-a";
export var hasLeftRadius = "_4c-i";
export var headerContainer = "_4c-3";
export var headerRow = "_4c-5";
export var hidePadding = "_4c-9";
export var navCollapsedGap = "_4c-j";
export var noScrollX = "_4c-k";
export var noScrollY = "_4c-l";
export var noTopPadding = "_4c-g";
export var optOutTopPadding = "_4c-b";
export var pageMain = "_4c-h";
export var pageOuter = "_4c-e";
export var pagePadding = "_4c-7";
export var profile = "_4c-m";
export var profileContainer = "_4c-n";
export var profileImage = "_4c-o";
export var profileMain = "_4c-p";
export var profileSubtitle = "_4c-r";
export var profileTitle = "_4c-q";
export var showLeftPadding = "_4c-f";
export var tabsWrapper = "_4c-4";
export var title = "_4c-s";